// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-form-group.form-group {
  margin-bottom: calc(var(--main-font-size-control) * 1.6);
}
.lsn-form-group.form-group.horizontal {
  align-items: center;
}
.lsn-form-group.form-group.align-with-baseline {
  align-items: baseline;
}
.lsn-form-group.form-group.vertical {
  row-gap: 0.4rem;
}
.lsn-form-group.form-group .lsn-group-label {
  line-height: normal;
}
.lsn-form-group.form-group.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/controls/Form/components/FormGroup/FormGroup.less"],"names":[],"mappings":"AAAA;EACE,wDAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,qBAAA;AAAJ;AAGE;EACE,eAAA;AADJ;AAXA;EAgBI,mBAAA;AAFJ;AAKE;EACE,aAAA;AAHJ","sourcesContent":[".lsn-form-group.form-group {\n  margin-bottom: calc(var(--main-font-size-control) * 1.6);\n\n  &.horizontal {\n    align-items: center;\n  }\n\n  &.align-with-baseline {\n    align-items: baseline;\n  }\n\n  &.vertical {\n    row-gap: .4rem;\n  }\n\n  .lsn-group-label {\n    line-height: normal;\n  }\n\n  &.hidden {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
